import * as Sentry from '@sentry/react';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { isDefined, isNonNullish } from 'remeda';
import { type Tenant, useValidateTenant } from 'shared/hooks/use-validate-tenant';
import apiService from 'shared/service/api.service';

import BadCompany from './Public/BadCompany';
import { ServerError } from './Public/ServerError';

interface TenantValidatorProps extends React.PropsWithChildren<{}> {}

// @ts-expect-error We ignore the type error here because we inforce the invariant below; we don't
// want to spend our time doing conditional navifgation on the tenant when the app just shouldn't load as song as it's not loaded
export const tenantAtom = atom<Tenant>(undefined);
tenantAtom.debugLabel = 'Tenant';

export const useTenant = () => useAtomValue(tenantAtom);

export const TenantValidator = ({ children }: TenantValidatorProps) => {
  const { tenant, tenantError } = useValidateTenant(apiService.tenant);
  const setTenant = useSetAtom(tenantAtom);

  useEffect(() => {
    if (isDefined(tenant)) {
      setTenant(tenant);
      Sentry.setTag('tenant', tenant?.domain);
    }
  }, [tenant, setTenant]);

  if (tenantError?.response?.status === 404) return <BadCompany />;
  if (isNonNullish(tenantError)) return <ServerError />;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
